import { render, staticRenderFns } from "./PasswordResetSuccessCard.vue?vue&type=template&id=0aa5b442"
import script from "./PasswordResetSuccessCard.vue?vue&type=script&lang=js"
export * from "./PasswordResetSuccessCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa5b442')) {
      api.createRecord('0aa5b442', component.options)
    } else {
      api.reload('0aa5b442', component.options)
    }
    module.hot.accept("./PasswordResetSuccessCard.vue?vue&type=template&id=0aa5b442", function () {
      api.rerender('0aa5b442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messages/PasswordResetSuccessCard.vue"
export default component.exports